import { useEffect, useState } from "react";
import { TaskModal } from "./components/TaskModal/TaskModal";
import { getTechnicalTaskText } from "./services/technical-task.service";
import { useTelegram } from "./hooks/useTelegram";
import type { TechnicalTaskResponse } from "./types/technical-task";
import "./App.css";
// const { isReady, safeAreaInset, calculateSafeAreaInset, initializeTelegram, isInTelegram } =
//   useTelegram()
function App() {
  const [taskData, setTaskData] = useState<TechnicalTaskResponse | null>(null);
  const [hasTasks, setHasTasks] = useState(false);
  const { user, safeAreaInset } = useTelegram();

  useEffect(() => {
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.ready();
      tg.expand();
      tg.requestFullscreen();
    }
  }, []);

  useEffect(() => {
    const loadTaskData = async () => {
      if (!user?.id) return;

      try {
        const response = await getTechnicalTaskText(user.id.toString());
        const data = response.data;

        if ("error" in data && data.error === "No tasks found for this user") {
          setHasTasks(false);
          setTaskData(null);
        } else if ("text" in data && "name" in data && "type" in data) {
          setTaskData(data as TechnicalTaskResponse);
          setHasTasks(true);
        }
      } catch (err) {
        console.error("Failed to load task data:", err);
        setHasTasks(false);
        setTaskData(null);
      }
    };

    loadTaskData();
  }, [user?.id]);

  const closeModal = () => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.close();
    }
  };

  return (
    <div className="app" style={{ paddingTop: `${safeAreaInset}px` }}>
      <TaskModal onClose={closeModal} taskData={taskData} hasTasks={hasTasks} />
    </div>
  );
}

export default App;
